import React from 'react';
import EnhancedModal, { ModalHeader, ModalBody, ModalFooter, ModalButton } from './EnhancedModal';
import { useTheme } from '../contexts/ThemeContext';

const RecurrenceDeleteModal = ({ isOpen, onClose, onConfirm, appointment }) => {
  const { theme } = useTheme();
  const isDarkMode = document.documentElement.classList.contains('dark');

  const handleConfirm = (scope) => {
    onConfirm(scope);
    onClose();
  };

  if (!isOpen || !appointment) return null;

  return (
    <EnhancedModal onClose={onClose} size="md">
      <ModalHeader>
        Suppression d'un rendez-vous récurrent
      </ModalHeader>
      <ModalBody>
        <div className="space-y-4">
          <p className={isDarkMode ? 'text-gray-300' : 'text-gray-700'}>
            Ce rendez-vous fait partie d'une série récurrente. Souhaitez-vous supprimer :
          </p>
          
          <div className="space-y-2">
            <button
              onClick={() => handleConfirm('this')}
              className={`w-full p-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                isDarkMode
                  ? 'bg-blue-600 hover:bg-blue-700 text-white'
                  : 'bg-blue-500 hover:bg-blue-600 text-white'
              }`}
            >
              Seulement ce rendez-vous
            </button>
            
            <button
              onClick={() => handleConfirm('future')}
              className={`w-full p-3 rounded focus:outline-none focus:ring-2 focus:ring-red-500 transition-colors ${
                isDarkMode
                  ? 'bg-red-600 hover:bg-red-700 text-white'
                  : 'bg-red-500 hover:bg-red-600 text-white'
              }`}
            >
              Ce rendez-vous et tous les suivants
            </button>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <ModalButton variant="secondary" onClick={onClose}>
          Annuler
        </ModalButton>
      </ModalFooter>
    </EnhancedModal>
  );
};

export default RecurrenceDeleteModal;
